// External destinations outside this portal.

// The partner marketing / details page. This portal has no landing page of its
// own — "back" links and logo clicks leave the app and go here.
export const PARTNERS_SITE_URL =
  process.env.REACT_APP_PARTNERS_SITE_URL || 'https://expedify.ai/partners';

// The partner discovery call. Booked on the application's success screen rather than
// promised by email: the applicant has just answered six questions and is at the peak of
// their intent, and a booking that waits on an email round-trip is a booking you lose.
// Prefilled from those same six answers, so nothing is typed twice.
export const PARTNER_BOOKING_URL =
  process.env.REACT_APP_PARTNER_BOOKING_URL ||
  'https://calendly.com/discovery-expedify/expedify-partnership';

// The same booking link, prefilled from whoever is signed in. Used by the application's
// success screen and by the "Talk to Experts" button in the portal header, so a partner
// never types their own name and email into our own calendar.
//
// `name` and `email` are Calendly's built-in fields; custom questions are numbered a1..aN
// POSITIONALLY, so none are sent — the day somebody adds a question to the event, a
// speculative a1 would quietly land in whatever that question happens to be.
//
// `URLSearchParams` encodes a space as "+", and Calendly renders that literally ("Shashank
// +Sharma"), so it is re-encoded to %20. A genuine "+" in a value is already %2B by then.
// hide_gdpr_banner keeps the embed from stacking a second consent bar inside our page.
export function partnerBookingUrl(user) {
  const params = new URLSearchParams({
    name: user?.full_name || '',
    email: user?.email || '',
  });
  return `${PARTNER_BOOKING_URL}?${params.toString().replace(/\+/g, '%20')}&hide_gdpr_banner=1`;
}

// The Privacy Policy. Linked from the registration tick-box, and incorporated into the partner
// agreement at §17.6 — the agreement is the hashed artefact, so the acceptance record proves
// agreement to a document that references this policy. Keep the two in step: if this URL moves,
// §17.6 moves with it, and moving §17.6 means a new terms version.
export const PRIVACY_POLICY_URL =
  process.env.REACT_APP_PRIVACY_POLICY_URL || 'https://expedify.ai/privacy';
